define('analytics',[
  'utils/constants',
  'utils/wrapper',
  'runtime',
  'easyXDM/easyXDM',
  'sdk/ui',
  'rpc',
  'options',
  'logger',
  'utils/cookies',
  'utils/domain'
],
function(CONST, __w, Runtime, XDM, UI, RPC, Options, Logger, Cookies, Domain) {
  XDM.apply(RPC.jsonRpcConfig, {
    remote: {
      api: {}
    },
    local: {
      analyticsEvent: function(params) {
        Logger.log('Analytics event with params', params);
      }
    }
  }, true);

  var uuid;
  var disabled = false;
  var playCalled = false;
  var uuidSet = false;

  var Analytics = {

    getXdHandler: function() {
      return RPC.xdHandler();
    },

    ieVersion: function() {
      var rv = 0; // Return value assumes failure.
      if (navigator.appName == 'Microsoft Internet Explorer') {
        var ua = navigator.userAgent;
        var re  = new RegExp('MSIE ([0-9]{1,}[\.0-9]{0,})');
        if (re.exec(ua) != null)
          rv = parseFloat( RegExp.$1 );
      }
      return rv;
    },

    reset: function() {
      disabled = false;
      Cookies.setCookie(Runtime.__options.appId, '', -1);
    },

    init: function(id) {
      if (Analytics.ieVersion() > 0 && Analytics.ieVersion() < 10) {
        // welcome to the carnival.
        // these browsers have lost all hope to work properly with CORS, so instead of using ugly
        // hacks and risking to break the SDK, we will include tracking pixel instead of doing cors request
        Analytics.trackWithPixel('play');
      } else {
        // for normal browsers, this will check exclusions (if cookie was not set) and then console.log
        // 'play' event since init happens on app load. We count app load as one play.
        // this will handle UUID retrieval and persistence too
        Analytics.trackWithCORS(id);
      }
    },

    trackWithCORS: function(id) {
      id.Event.monitor('options', function() {
        disabled = false;
        if (Options.get.stats) {
           Analytics.tracker({
             event: 'play',
             game_id: Runtime.__options.appId,
             domain: Domain.getDomain()
           });
        }else{
          disabled = true;
        }
      });
    },

    trackWithPixel: function(eventType) {
      var body = document.getElementsByTagName('body')[0];
      var pixel, html;
      var url = '//t.id.net/px.gif?game_id=' + Runtime.__options.appId +
        '&event=' + eventType +
        '&domain=' + Domain.getDomain();
      pixel = document.createElement('img');
      pixel.src = url;
      pixel.style = 'visibility:hidden; position:absolute';
      body.appendChild(pixel);
    },

    tracker: function(params) {
      if (Analytics.ieVersion() > 0 && Analytics.ieVersion() < 10) {
        Analytics.trackWithPixel(params.event);
        return;
      }

      if (disabled) {
        return;
      }
      if (params.event == 'play' && !playCalled) {
        playCalled = true;
      } else if (params.event == 'play' && playCalled) {
        Logger.log('play event already sent');
      }
      var success = function(data) {
        try{
          data = JSON.parse(data);
        } catch(e) {
          Logger.log('failed setting uuid' + e);
        }
        Analytics.set_uuid(data.uuid);
      };
      var fail = function(e) {
        Logger.log('tracker failed', e);
      };
      Analytics.get_uuid(function(uuid) {
        if (uuid) {
          params.uuid = uuid;
        }
        params.user_agent = navigator.userAgent;
        params.sdk = 'js';
        Analytics.getXdHandler().api({
          method: 'POST',
          url: CONST.analytics_url,
          data: params
        }, success, fail);
      });
    },

    get_uuid: function(callback) {
      if (uuid) {
        callback(uuid);
      }
      Analytics.getXdHandler().api({
        method: 'GET',
        url: CONST.root_url + '/api/v1/json/tracking/get_uuid',
        data: null
      }, function(data) {
        try {
          data = JSON.parse(data);
        } catch(e) {
          Logger.log('failed to parse json data', e);
        }
        if (data && data.hasOwnProperty('uuid') && data.uuid) {
          callback(data.uuid);
        } else {
          callback(Cookies.getCookie('uuid'));
        }
      }, function(error) {
        Logger.log('get uuid failed', error);
      });
    },

    set_uuid: function(uuid) {
      if (uuidSet) {
        return;
      }
      this.uuid = uuid;
      Analytics.getXdHandler().api({
        method: 'POST',
        url: CONST.root_url + '/api/v1/json/tracking/set_uuid',
        data: {uuid: uuid}},
        function(d) {
          //Analytics.log(d);
        },
        function(error) {
          Analytics.log('set_uuid error');
          Analytics.log(error);
        });
      Cookies.setCookie('uuid', uuid, 365);
      uuidSet = true;
    },

    // the developer object is exposed in the sdk
    developer: {
      custom_event: function(name, value) {
        var params = {
          event: 'custom',
          game_id: Runtime.__options.appId,
          domain: Domain.getDomain(),
          custom_event: {
            name: name,
            value: value,
          },
        };
        Analytics.tracker(params);
      },
    },
  };
  return Analytics;
});

